const NANP_E164_REGEX = /^\+1(\d{3})(\d{3})(\d{2})(\d{2})$/;

export const formatMaskedPhoneIdentifier = (value: string | null | undefined): string => {
  if (!value) {
    return "your phone";
  }
  const match = value.match(NANP_E164_REGEX);
  // Guard match[4] explicitly — under noUncheckedIndexedAccess the regex group
  // is `string | undefined` even when the match succeeded.
  if (!match || !match[4]) {
    return value;
  }
  return `+1 *** *** **${match[4]}`;
};
